import { render } from "./LeftPanel.vue?vue&type=template&id=4bd664a3&scoped=true"
import script from "./LeftPanel.vue?vue&type=script&lang=js"
export * from "./LeftPanel.vue?vue&type=script&lang=js"

import "./LeftPanel.vue?vue&type=style&index=0&id=4bd664a3&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bd664a3"]])

export default __exports__